import React from 'react';

import { webhooksActions, modalState } from '../../../../redux/reducers/webhooks';
import { useAppSelector, useAppDispatch } from '../../../../hooks/useRedux';

import CreateWebhook from './CreateWebhook';
import GenerateNewSecret from './GenerateNewSecret';
import DeleteWebhook from './DeleteWebhook';
import UploadCertificate from './UploadCertificate';
import DeleteCertificate from './DeleteCertificate';

function ModalsContainer() {
  const dispatch = useAppDispatch();
  const activeModal = useAppSelector(modalState);

  function renderModal() {
    switch (activeModal.name) {
      case 'create a webhook':
        return <CreateWebhook closeModal={(value) => dispatch(webhooksActions.setActiveModalDetails(value))} />;
      case 'new webhook secret':
        return <GenerateNewSecret closeModal={(value) => dispatch(webhooksActions.setActiveModalDetails(value))} />;
      case 'delete a webhook':
        return <DeleteWebhook closeModal={(value) => dispatch(webhooksActions.setActiveModalDetails(value))} />;
      case 'upload a certificate':
        return <UploadCertificate closeModal={(value) => dispatch(webhooksActions.setActiveModalDetails(value))} />;
      case 'delete a certificate':
        return <DeleteCertificate closeModal={(value) => dispatch(webhooksActions.setActiveModalDetails(value))} />;
      default:
        return null;
    }
  }

  return renderModal();
}

export default ModalsContainer;
